export const AdverseDrugEventOptions = [
    {
        description: "Was there documentation of an allergy?",
        name: "WasThereDocumentationOfAnAllergy_DR",
    },
    {
        description: "Are there any known contraindications with the medications the patient is currently taking?",
        name: "KnownContraindicationsWithTheMedications_DR",
    },
];